module.exports = __webpack_public_path__ + "static/image-right1-202c6f2b29a2e50a137253f112e4aa01.jpg";